<div class="main-container">
  <div class="row-container" *ngIf="data">
    <ion-col class="recurrent-data" [ngClass]="{'date-item': item == 'Date'}" size="2" *ngFor="let item of config">
      {{data[item]}}
    </ion-col>
  </div>

</div>